enum ShipmentStatusEnum {
    AWAITING_PAYMENT = 1,
    AWAITING_FULFILLMENT,
    AWAITING_SHIPMENT,
    AWAITING_PICKUP,
    PARTIALLY_SHIPPED,
    COMPLETED,
    SHIPPED,
    CANCELLED,
    DECLINED,
    REFUNDED,
    VERIFICATION_REQUIRED,
    PARTIALLY_REFUNDED,
    READY_FOR_PICKUP,
    READY_FOR_DELIVERY,
    DELIVERED,
    PICKED_UP,
}

export default ShipmentStatusEnum;
